import { Types } from "../actions/SparePartActions";

const initialState = {
  sparePartList: {},
  sparePartUsageList: {},
  sparePartLogList: {},
  sparePartUsagePlannedList: {},
  poolList: null,
  materialDescriptions: [],
  deletedSp: {},
  selectedSparePartList: {},
  addSparePartRes: {},
  updateSparePartRes: {},
  sparePartNoteList: { resultObject: [] },
  addSparePartNote: {},
  updateSparePartNoteRes: {},
  deleteSparePartNote: null,
};

export const SparePartReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_SPARE_PART_LIST:
      return {
        ...state,
        sparePartList: action.payload || state.sparePartList,
      };
    case Types.SET_SPARE_PART_USAGE_LIST:
      return {
        ...state,
        sparePartUsageList: action.payload || state.sparePartUsageList,
      };
    case Types.SET_SPARE_PART_LOG_LIST:
      return {
        ...state,
        sparePartLogList: action.payload || state.sparePartLogList,
      };
    case Types.SET_SELECTED_SPARE_PART_LIST:
      return {
        ...state,
        selectedSparePartList: action.payload || state.selectedSparePartList,
      };
    case Types.SET_SPARE_PART_USAGE_PLANNED_LIST:
      return {
        ...state,
        sparePartUsagePlannedList:
          action.payload || state.sparePartUsagePlannedList,
      };
    case Types.SET_POOL_LIST_FOR_SPARE_PART_LIST:
      return {
        ...state,
        poolList: action.payload.resultObject,
      };
    case Types.SET_LIST_STOCK_CODES_AND_MATERIAL_DESCRIPTIONS:
      return {
        ...state,
        materialDescriptions: action.payload || state.materialDescriptions,
      };
    case Types.DELETE_SPARE_PART_RES:
      return {
        ...state,
        deletedSp: action.payload || state.deletedEq,
      };
    case Types.ADD_SPARE_PART_RES:
      return {
        ...state,
        addSparePartRes: action.payload || state.addSparePartRes,
      };
    case Types.RESET_DELETED_SP:
      return {
        ...state,
        deletedSp: {},
      };
    case Types.UPDATE_SPARE_PART_SUCCESS:
      return {
        ...state,
        updateSparePartRes: action.payload,
      };
    case Types.ADD_SPARE_PART_NOTE:
      return {
        ...state,
        addSparePartNote: action.payload || state.addSparePartNote
      };
    case Types.SET_SPARE_PART_NOTE_LIST:
      return {
        ...state,
        sparePartNoteList: action.payload || state.sparePartNoteList
      }
    case Types.UPDATE_SPARE_PART_NOTE:
      return {
        ...state,
        updateSparePartNoteRes: action.payload || state.updateSparePartNoteRes
      }
    case Types.SET_DELETE_SPARE_PART_NOTE:
      return {
        ...state,
        deleteSparePartNote: action.payload,
      };
    default:
      return state;
  }
};
